import { Parts } from './modules/renderSilhouette/component';
import { RenderedBodyPart } from './component';

export const initialBodyPartsWoman: RenderedBodyPart[] = [
    {
        name: Parts.Thighs,
        localeName: 'Uda',
        side: 'left',
        active: false,
        product: null,
    }, {
        name: Parts.Calves,
        localeName: 'Łydki',
        side: 'left',
        active: false,
        product: null,
    }, {
        name: Parts.Feet,
        localeName: 'Stopy',
        side: 'left',
        active: false,
        product: null,
    }, {
        name: Parts.Buttocks,
        localeName: 'Pośladki',
        side: 'left',
        active: false,
        product: null,
    }, {
        name: Parts.Face,
        localeName: 'Twarz',
        side: 'right',
        active: false,
        product: null,
    }, {
        name: Parts.Tummy,
        localeName: 'Brzuch',
        side: 'right',
        active: false,
        product: null,
    }, {
        name: Parts.Armpits,
        localeName: 'Pachy',
        side: 'right',
        active: false,
        product: null,
    }, {
        name: Parts.Feet,
        localeName: 'Stopy',
        side: 'right',
        active: false,
        product: null,
    }, {
        name: Parts.Thighs,
        localeName: 'Uda',
        side: 'right',
        active: false,
        product: null,
    }, {
        name: Parts.Bikini,
        localeName: 'Bikini',
        side: 'right',
        active: false,
        product: null,
    }, {
        name: Parts.Arms,
        localeName: 'Ramiona',
        side: 'right',
        active: false,
        product: null,
    }, {
        name: Parts.Hands,
        localeName: 'Ręce',
        side: 'right',
        active: false,
        product: null,
    },
    {
        name: Parts.Mustache,
        localeName: 'Wąsik',
        side: 'right',
        active: false,
        product: null,
    },
    {
        name: Parts.Chin,
        localeName: 'Podbródek',
        side: 'right',
        active: false,
        product: null,
    },
    {
        name: Parts.Palm,
        localeName: 'Dłonie',
        side: 'right',
        active: false,
        product: null,
    },
    {
        name: Parts.WhiteLine,
        localeName: 'Linia biała',
        side: 'right',
        active: false,
        product: null,
    },
];
